import { Clock, HeartCrack, Repeat, Shuffle } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const pains = [
  {
    icon: Shuffle,
    title: "Confusão de dietas",
    text: "Low carb, jejum, detox… cada semana uma regra nova, e nenhuma delas dura até o fim do mês.",
  },
  {
    icon: Repeat,
    title: "Efeito sanfona",
    text: "Você começa animada na segunda-feira e, na sexta, já sente que estragou tudo de novo.",
  },
  {
    icon: Clock,
    title: "Falta de tempo",
    text: "Rotina corrida, mil decisões por dia — e a comida saudável sempre fica para “depois”.",
  },
  {
    icon: HeartCrack,
    title: "Culpa no prato",
    text: "Saiu um pouco do plano e bate aquela sensação de fracasso que faz você desistir de vez.",
  },
];

export default function PainPoints() {
  return (
    <section data-testid="pain-section" className="bg-sand/60 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>Você não está sozinha</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl">
              Se sente perdida na hora de escolher{" "}
              <span className="italic text-terracotta">o que comer?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-4 text-base leading-relaxed text-moss sm:text-lg">
              O problema nunca foi falta de força de vontade. Foi falta de método.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <Reveal className="sm:col-span-2 lg:row-span-2" delay={0.1}>
            <div className="relative h-full min-h-[280px] overflow-hidden rounded-3xl border border-linen">
              <img
                src="https://images.unsplash.com/photo-1542814880-7e62cf14b7c8?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Mesa com comida fresca e colorida"
                data-testid="pain-image"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
              <p className="absolute bottom-6 left-6 right-6 font-serif text-xl italic leading-snug text-cream sm:text-2xl">
                “Metade feita vale mais que o livro inteiro parado.”
              </p>
            </div>
          </Reveal>

          {pains.map((pain, i) => (
            <Reveal key={pain.title} delay={0.12 + i * 0.08}>
              <div
                data-testid={`pain-card-${i + 1}`}
                className="group h-full rounded-3xl border border-linen bg-white p-7 shadow-sm transition-transform duration-300 hover:-translate-y-1.5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-mint text-forest transition-colors group-hover:bg-terracotta group-hover:text-cream">
                  <pain.icon size={19} strokeWidth={2.1} />
                </span>
                <h3 className="mt-5 font-serif text-xl font-medium text-ink">{pain.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-moss">{pain.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
